<div
     snAssistantSurface="newSpace"
     i18n-surfaceTitle="@@newSpace.surface"
     surfaceTitle="New workspace" class="space-create-container">
  <form [formGroup]="createForm" (ngSubmit)="onSubmit()">
    <!-- Header -->
    <div class="header-section">
      <h1>Create workspace</h1>
      <p class="subtitle">Set up a new workspace for your team collaboration</p>
    </div>

    <!-- Workspace Name Field -->
    <div class="form-field">
      <label class="field-label">
        Workspace Name <span class="required">*</span>
      </label>

      <div class="input-wrapper">
        <input
          pInputText
          type="text"
          formControlName="name"
          placeholder="Enter workspace name"
          class="name-input"
          [maxlength]="maxNameLength">

        <span class="character-count">{{ nameLength }}/{{ maxNameLength }}</span>
      </div>

      @if (nameControl?.invalid && nameControl?.touched) {
        <div class="field-error">
          @if (nameControl?.errors?.['required']) {
            <span>Workspace name is required</span>
          }
          @if (nameControl?.errors?.['maxlength']) {
            <span>Workspace name cannot exceed {{ maxNameLength }} characters</span>
          }
        </div>
      }
    </div>

    <!-- Description Field -->
    <div class="form-field">
      <label class="field-label">
        Description <span class="optional">(optional)</span>
      </label>

      <div class="input-wrapper">
        <textarea
          pTextarea
          formControlName="description"
          placeholder="Describe the purpose of this workspace"
          class="description-input"
          [maxlength]="maxDescriptionLength"
          rows="3"
          [autoResize]="true">
        </textarea>

        <span class="character-count">{{ descriptionLength }}/{{ maxDescriptionLength }}</span>
      </div>

      @if (descriptionControl?.invalid && descriptionControl?.touched) {
        <div class="field-error">
          @if (descriptionControl?.errors?.['maxlength']) {
            <span>Description cannot exceed {{ maxDescriptionLength }} characters</span>
          }
        </div>
      }
    </div>

    <!-- Action Buttons -->
    <div class="actions-section">
      <p-button
        type="button"
        label="Back"
        severity="secondary"
        [outlined]="true"
        icon="pi pi-arrow-left"
        (click)="goBack()">
      </p-button>

      <p-button
        type="submit"
        label="Create Workspace"
        [loading]="loading()"
        [disabled]="createForm.invalid"
        snAssistantAction="create"
        actionHint="Creates the workspace and switches to it. Agents, numbers and billing of a workspace are separate from every other one.">
      </p-button>
    </div>
  </form>
</div>